export default "__VITE_ASSET__DEUh7s$F__"